import { PayoutType, ExpensesType } from 'types';

export const payoutTitles: Record<PayoutType, string> = {
  [PayoutType.Tip]: 'Tip',
  [PayoutType.Fee]: 'Fee',
  [PayoutType.Misc]: 'Misc',
  [PayoutType.Bonus]: 'Bonus',
  [PayoutType.Refund]: 'Refund',
  [PayoutType.Advance]: 'Advance',
  [PayoutType.Dispute]: 'Dispute',
  [PayoutType.Penalty]: 'Penalty',
  [PayoutType.Expense]: 'Expense',
  [PayoutType.Earnings]: 'Commissions',
  [PayoutType.Adjustment]: 'Adjustment',
  [PayoutType.NegativeTip]: 'Negative Tip',
  [PayoutType.PrepaidBonus]: 'Prepaid Bonus',
  [PayoutType.FreeShipping]: 'Free Shipping',
  [PayoutType.Reimbursements]: 'Reimbursements',
  [PayoutType.PrepaidExpense]: 'Prepaid Expense',
  [PayoutType.PrepaidAdvance]: 'Prepaid Advance',
  [PayoutType.NegativeEarnings]: 'Negative Commission',
  [PayoutType.NegativeAdjustment]: 'Negative Adjustment',
  [PayoutType.PrepaidReimbursements]: 'Prepaid Reimbursements',
};

export const deductions = [
  ExpensesType.Misc,
  ExpensesType.Advance,
  PayoutType.NegativeTip,
  PayoutType.FreeShipping,
  PayoutType.PrepaidAdvance,
  PayoutType.NegativeEarnings,
  PayoutType.NegativeAdjustment,
];

export const additions = [
  PayoutType.Tip,
  ExpensesType.Misc,
  ExpensesType.Bonus,
  PayoutType.Earnings,
  ExpensesType.Expense,
  PayoutType.PrepaidBonus,
  PayoutType.PrepaidExpense,
  ExpensesType.Reimbursement,
  PayoutType.PrepaidReimbursements,
];

export const staticMinusPayoutTypes = [
  PayoutType.Refund,
  PayoutType.Advance,
  PayoutType.NegativeTip,
  PayoutType.FreeShipping,
  PayoutType.PrepaidAdvance,
  PayoutType.NegativeEarnings,
  PayoutType.NegativeAdjustment,
];

export const signedAmountTypes = [
  PayoutType.Misc,
  PayoutType.Adjustment,
  PayoutType.Earnings,
];
